import {GridColumns} from '@mui/x-data-grid';
import {FormattedMessage} from 'react-intl';
import {Chip} from '@mui/material';
import {BexioAccountActions} from './BexioAccountActions';

export const columnConfigBexioAccounts = (
    onUnlinkAccount: (bexioAccountId: number) => void,
    onMakePrimary: (bexioAccountId: number) => void,
    onUpdateAccount: (bexioAccountId: number) => void
): GridColumns => [
    {
        field: 'bexioAccountId',
        renderHeader: () => <FormattedMessage id="bexioAccountId"/>,
        flex: 1,
        minWidth: 120,
        sortable: false,
        cellClassName: 'ampTableCell',
    },
    {
        field: 'companyName',
        renderHeader: () => <FormattedMessage id="companyName"/>,
        flex: 2,
        minWidth: 200,
        sortable: false,
        cellClassName: 'ampTableCell',
    },
    {
        field: 'bexioId',
        renderHeader: () => <FormattedMessage id="bexioId"/>,
        flex: 1,
        minWidth: 120,
        sortable: false,
        cellClassName: 'ampTableCell',
    },
    {
        field: 'primary',
        renderHeader: () => <FormattedMessage id="primaryAccount"/>,
        flex: 1,
        minWidth: 120,
        sortable: false,
        cellClassName: 'ampTableCell',
        renderCell: (params) => {
            return params.row.primary ? (
                <Chip
                    label={<FormattedMessage id="primary"/>}
                    size="small"
                    color="success"
                    variant="filled"
                />
            ) : (
                '-'
            );
        },
    },
    {
        field: 'actions',
        renderHeader: () => '',
        width: 120,
        sortable: false,
        cellClassName: 'ampTableCell',
        align: 'right' as const,
        headerAlign: 'right' as const,
        renderCell: (params) => (
            <BexioAccountActions
                bexioAccountId={params.row.bexioAccountId}
                isPrimary={params.row.primary}
                onUnlink={onUnlinkAccount}
                onMakePrimary={onMakePrimary}
                onUpdate={onUpdateAccount}
            />
        ),
    },
];